<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-01 16:44:16
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-29 14:43:01
-->
<template>
  <div class="yplus-button-row" :style="fixed?'padding-bottom:50px':''">
      <div class="yplus-button-row " :class="fixed?'button-fixed':''">
          <van-button class="van-button-new" :disabled="disabled" :native-type="nativeType" @click="$emit('click')" :color="color" block>{{text}}</van-button>
      </div>
      
  </div>
</template>

<script>
export default {
    props:{
        text:{
            type:String,
            default:''
        },
        fixed:{
            type:Boolean,
            default:false
        },
        color:{
            type:String,
            default:'#00BCD1'
        },
        nativeType:{
            type:String,
            default:''
        },
        disabled:{
           type:Boolean,
            default:false 
        }
    }
}
</script>

<style scoped>
.yplus-button-row{
    height: 13.3vw;
}
.button-fixed{
    width: 92vw;
    left: 4vw;
    position: fixed;
    bottom: 50px;
    /* height: 44px; */
}
.van-button-new{
    height: 13.3vw;
    font-size: 4.2vw;
    border-radius: 1.6vw;
}
</style>


// WEBPACK FOOTER //
// src/components/YButton.vue